import {useCallback, useState} from "react";

interface DialogInfos {
    onConfirm: () => void;
    text: string;
    buttonText: string;
}
export default function useConfirmationDialog(): [(dialogInfos: DialogInfos) => void, () => void, boolean, DialogInfos | undefined] {
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [dialogInfos, setDialogInfos] = useState<DialogInfos | undefined>(undefined);

    const openConfirmationDialog = useCallback((dialogInfos: {onConfirm: () => void, text: string, buttonText: string}) => {
        setDialogInfos(dialogInfos);
        setIsConfirmationModalOpen(true);
    }, []);

    const closeConfirmationDialog = useCallback(() => {
        setIsConfirmationModalOpen(false);
    }, []);

    return [openConfirmationDialog, closeConfirmationDialog, isConfirmationModalOpen, dialogInfos];
}
